import React from 'react';

const Owners = [
  {
    name: "Jamal White & Harry Goodwin",
    role: "Owners",
  }
];

const AboutUs = () => (
  <section id="about-us" className="py-12 md:py-20 bg-gray-50">
    <div className="max-w-6xl mx-auto px-4">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 md:mb-4">About Us</h2>
      <div className="h-1 w-20 md:w-24 bg-red-600 mx-auto mb-8 md:mb-12"></div>
      
      <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
        <div className="text-center">
          <div className="relative mb-6 inline-block">
            <img
              src="/images/NewHeadshots.png"
              alt="Company Owners"
              className="w-48 h-48 md:w-[32rem] md:h-96 rounded-lg object-cover"
            />
            <div className="absolute inset-0 rounded-lg border-2 border-red-600 opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
          </div>
          <div className="space-y-1">
            {Owners.map((owner, index) => (
              <h3 key={index} className="text-lg md:text-xl font-semibold">
                {owner.name}
              </h3>
            ))}
            <p className="text-gray-600 mt-2">{Owners[0].role}</p>
          </div>
        </div>
        
        <div className="space-y-4 md:space-y-6">
          <p className="text-base md:text-lg text-gray-700 leading-relaxed">
            We are two childhood friends who have always believed in the power of positivity and
            community support. From a young age, we found joy in helping others and spreading kindness
            wherever we went.
          </p>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed">
            Our shared passion for making a difference led us to collaborate on
            various community projects, where we focus on uplifting those around us and fostering a
            spirit of generosity.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default AboutUs;